import React, {useState, useRef} from "react";
import  Ardent_logo from '../../images/ArdentPropertiesInc.jpg'
import Ardent_address from '../../images/Ardent-IsolatedFranklynAddress.jpg' 
import { useEffect } from "react";
import { Link } from "react-router-dom";
import SignaturePad from 'react-signature-canvas'


import {
  Page,
  Text,
  View,
  Image,
  Document,
  StyleSheet,
  PDFDownloadLink,
  Canvas
} from "@react-pdf/renderer";
import { PDFViewer } from "@react-pdf/renderer";

import './RentalPdfPageStyle.css'

// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    backgroundColor: "#ffffff",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  heading: {
    fontSize: 26,
    textAlign: "center",
    marginBottom: 10,
  },
  text: {
    fontSize: 14,
  },
  image_div: {
    justifyContent: "center",
    display: "flex",
    alignItems: "center",
    paddingBottom: 10,
  },
  header_pic: {
    width: 450,
  },
  table: { 
    display: "table", 
    width: "auto", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderRightWidth: 0, 
    borderBottomWidth: 0 
  }, 
  tableRow: { 
    margin: "auto", 
    flexDirection: "row" 
  }, 
  tableCol: { 
    width: "33.3%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  }, 
  tableCell: { 
    margin: "auto", 
    marginTop: 5, 
    fontSize: 10 
  },
  sub_text: {
    fontSize: 10,
    paddingLeft: 25
  },
  sub_header: {
    fontSize: 15,
    paddingLeft: 10,
    paddingTop: 30
  },
  underline: {
    marginLeft: 200,
    width: "33.3%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  underlineDate: {
    marginLeft: 415,
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  underlineDateLandlord: {
    marginLeft: 435,
    width: "20%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  underlineTenat: {
    marginLeft: 180,
    width: "33.3%", 
    borderStyle: "solid", 
    borderWidth: 1, 
    borderLeftWidth: 0, 
    borderTopWidth: 0 
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 30,
    textAlign: 'right',
    color: 'black',
  },
});


// Create Document Component
const MyDocument = ({ landSignature, fileName, Address, tenantAttention, landlordAttention, tenantName, contact, currentDate, entrance_door_code, entrance_door_comment, entrance_floor_code, entrance_floor_comment, entrance_wall_code, entrance_wall_comment, entrance_ceiling_code, entrance_ceiling_comment, entrance_light_code, entrance_light_comment, entrance_smoke_code, entrance_smoke_comment, entrance_fire_code, entrance_fire_comment, entrance_closet_code, entrance_closet_comment, entrance_stairwell_code, entrance_stairwell_comment, entrance_gc_code, entrance_gc_comment, entrance_comment_code, entrance_comment_comment,  kitchen_appliances_code, kitchen_appliances_comment, kitchen_cabinetry_code , kitchen_cabinetry_comment , kitchen_plumbing_code , kitchen_plumbing_comment ,  kitchen_fan_code ,  kitchen_fan_comment , kitchen_window_code , kitchen_window_comment , kitchen_floor_code , kitchen_floor_comment , kitchen_ceiling_code ,  kitchen_ceiling_comment , kitchen_gc_code , kitchen_gc_comment , kitchen_comment_code , kitchen_comment_comment ,dining_floor_code , dining_floor_comment , dining_wall_code , dining_wall_comment , dining_ceiling_code , dining_ceiling_comment , dining_window_code , dining_window_comment , dining_gc_code , dining_gc_comment , dining_comment_code , dining_comment_comment ,living_floor_code , living_floor_comment , living_wall_code , living_wall_comment , living_ceiling_code , living_ceiling_comment , living_windows_code , living_windows_comment , living_fire_code , living_fire_comment , living_gc_code ,living_gc_comment , living_comment_code , living_comment_comment ,bath_m_door_code ,  bath_m_door_comment ,bath_m_floor_code ,bath_m_floor_comment , bath_m_cabinetry_code , bath_m_cabinetry_comment , bath_m_plumbing_code , bath_m_plumbing_comment , bath_m_bath_code , bath_m_bath_comment , bath_m_ceiling_code , bath_m_ceiling_comment , bath_m_light_code , bath_m_light_comment , bath_m_window_code , bath_m_window_comment , bath_m_gc_code , bath_m_gc_comment , bath_m_comment_code ,bath_m_comment_comment ,master_door_code , master_door_comment , master_floor_code , master_floor_comment , master_wall_code , master_wall_comment , master_ceiling_code , master_ceiling_comment , master_closet_code , master_closet_comment , master_window_code , master_window_comment , master_gc_code , master_gc_comment , master_comment_code ,master_comment_comment ,bath_e_door_code , bath_e_door_comment , bath_e_floor_code , bath_e_floor_comment , bath_e_walls_code, bath_e_walls_comment, bath_e_cabinetry_code , bath_e_cabinetry_comment , bath_e_plumbing_code , bath_e_plumbing_comment , bath_e_bath_code ,bath_e_bath_comment, bath_e_ceiling_code, bath_e_ceiling_comment ,bath_e_light_code , bath_e_light_comment, bath_e_window_code, bath_e_window_comment, bath_e_gc_code, bath_e_gc_comment, bath_e_comment_code,bath_e_comment_comment, bed2_door_code, bed2_door_comment, bed2_floor_code ,bed2_floor_comment, bed2_wall_code, bed2_wall_comment, bed2_ceiling_code, bed2_ceiling_comment , bed2_closet_code , bed2_closet_comment, bed2_window_code , bed2_window_comment , bed2_gc_code , bed2_gc_comment ,bed2_comment_code,bed2_comment_comment,bed3_door_code, bed3_door_comment, bed3_floor_code, bed3_floor_comment, bed3_wall_code , bed3_wall_comment , bed3_ceiling_code ,bed3_ceiling_comment , bed3_closet_code , bed3_closet_comment, bed3_window_code, bed3_window_comment ,  bed3_gc_code ,  bed3_gc_comment , bed3_comment_code ,bed3_comment_comment ,bed4_door_code, bed4_door_comment, bed4_floor_code, bed4_floor_comment, bed4_wall_code, bed4_wall_comment, bed4_ceiling_code, bed4_ceiling_comment, bed4_closet_code,  bed4_closet_comment, bed4_window_code, bed4_window_comment, bed4_gc_code, bed4_gc_comment, bed4_comment_code,bed4_comment_comment,family_floor_code, family_floor_comment, family_wall_code, family_wall_comment, family_ceiling_code, family_ceiling_comment, family_light_code, family_light_comment, family_window_code, family_window_comment,family_fire_code, family_fire_comment,  family_gc_code, family_gc_comment, family_comment_code,family_comment_comment, laundry_door_code, laundry_door_comment, laundry_floor_code, laundry_floor_comment, laundry_wall_code, laundry_wall_comment,laundry_ceiling_code, laundry_ceiling_comment, laundry_washer_code, laundry_washer_comment, laundry_window_code, laundry_window_comment, laundry_gc_code, laundry_gc_comment, laundry_comment_code,laundry_comment_comment,basement_floor_code, basement_floor_comment, basement_wall_code, basement_wall_comment, basement_ceiling_code, basement_ceiling_comment, basement_smoke_code, basement_smoke_comment, basement_window_code, basement_window_comment, basement_plumbing_code, basement_plumbing_comment, basement_vacuum_code, basement_vacuum_comment, basement_hot_code, basement_hot_comment, basement_oil_code, basement_oil_comment, basement_gc_code, basement_gc_comment, basement_comment_code, basement_comment_comment, exterior_patio_code, exterior_patio_comment, exterior_deck_code, exterior_deck_comment, exterior_stairs_code, exterior_stairs_comment, exterior_light_code, exterior_light_comment, exterior_roof_code, exterior_roof_comment, exterior_gutter_code, exterior_gutter_comment, exterior_driveway_code, exterior_driveway_comment, exterior_siding_code, exterior_siding_comment, exterior_oil_code, exterior_oil_comment, exterior_garage_code, exterior_garage_comment, exterior_fencing_code, exterior_fencing_comment, exterior_landscaping_code, exterior_landscaping_comment, exterior_shed_code, exterior_shed_comment, exterior_other_code, exterior_other_comment, exterior_gc_code, exterior_gc_comment, exterior_comment_code, exterior_comment_comment }) => {

  return (
    <Document title={fileName}>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <View style= {styles.image_div}>
        <Image style={styles.header_pic} src={Ardent_logo}></Image>
        <Image style={styles.header_pic} src={Ardent_address}></Image>
      </View>
        
        <Text style={styles.text}>ADDRESS OF PROPERTY: {Address}</Text>
        <Text style={styles.text}>TENANT(S) NAME: {tenantName}</Text>
        <Text style={styles.text}>CONTACT INFO: {contact}</Text>
        <Text style={styles.text}>DATE: {currentDate}</Text>


    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>ENTRANCE & HALLWAY</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Light Fixtures:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_light_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_light_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Smoke/CO Detectors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_smoke_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_smoke_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Fire Extinguishers:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_fire_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_fire_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Closet(s):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_closet_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_closet_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Stairwell:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_stairwell_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_stairwell_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{entrance_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{entrance_comment_comment}</Text> 
        </View>
      </View>
    </View>


    {/* !!!!!!!!!!!!!!!!!!!!! START OF KITCHEN !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>KITCHEN</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Appliances:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_appliances_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_appliances_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Cabinetry & countertops:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_cabinetry_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_cabinetry_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Plumbing:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_plumbing_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_plumbing_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Hood Fan:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_fan_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_fan_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{kitchen_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{kitchen_comment_comment}</Text> 
        </View>
      </View>
    </View>


    {/* !!!!!!!!!!!!!!!!!!!!!!! START OF DINING ROOM !!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>DINING ROOM</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{dining_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{dining_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{dining_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{dining_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{dining_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{dining_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{dining_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{dining_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{dining_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{dining_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{dining_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{dining_comment_comment}</Text> 
        </View>
      </View>
    </View>
    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `page ${pageNumber} of ${totalPages}`
      )} fixed />
  </View>
  </Page>
  <Page  size="A4" style={styles.page}>
    <View style={styles.section}>
        <View style= {styles.image_div}>
        <Image style={styles.header_pic} src={Ardent_logo}></Image>
        <Image style={styles.header_pic} src={Ardent_address}></Image>
      </View>
  

    {/*  !!!!!!!!!!!!!!!!!!!!!!!!!!!! START OF LIVING ROOM !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!*/ }
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>LIVING ROOM</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{living_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{living_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{living_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{living_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{living_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{living_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{living_windows_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{living_windows_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Fireplace:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{living_fire_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{living_fire_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Gerneral Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{living_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{living_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{living_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{living_comment_comment}</Text> 
        </View>
      </View>
    </View>



  {/* !!!!!!!!!!!!!!!!!!!!!! BATHROOM - MAIN !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>BATHROOM - MAIN</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Cabinetry & Countertops:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_cabinetry_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_cabinetry_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Plumbing:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_plumbing_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_plumbing_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Bathtub/Shower:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_bath_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_bath_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Light Fixtures:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_light_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_light_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_m_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_m_comment_comment}</Text> 
        </View>
      </View>
    </View>




    {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! START OF MASTER BEDROOM !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>MASTER BEDROOM</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{master_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{master_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{master_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{master_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{master_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{master_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{master_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{master_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Closet(s):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{master_closet_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{master_closet_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{master_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{master_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{master_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{master_comment_comment}</Text> 
        </View>
      </View>
    </View>



    {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! START OF BATHROOM - ENSUITE !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>BATHROOM - ENSUITE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Cabinetry & Countertops:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_cabinetry_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_cabinetry_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Plumbing:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_plumbing_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_plumbing_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Bathtub/Shower:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_bath_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_bath_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_walls_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_walls_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Light Fixtures:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_light_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_light_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bath_e_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bath_e_comment_comment}</Text> 
        </View>
      </View>
    </View>
    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `page ${pageNumber} of ${totalPages}`
      )} fixed />
    </View>
    </Page>
    <Page  size="A4" style={styles.page}>
    <View style={styles.section}>
        <View style= {styles.image_div}>
        <Image style={styles.header_pic} src={Ardent_logo}></Image>
        <Image style={styles.header_pic} src={Ardent_address}></Image>
      </View>


    {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!  START OF BEDROOM #2 !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>BEDROOM #2</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Closet(s):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_closet_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_closet_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed2_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed2_comment_comment}</Text> 
        </View>
      </View>
    </View>





    {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!  START OF BEDROOM #3 !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>BEDROOM #3</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Closet(s):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_closet_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_closet_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed3_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed3_comment_comment}</Text> 
        </View>
      </View>
    </View>





          {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!  START OF BEDROOM #4 !!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
          <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>BEDROOM #4</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Closet(s):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_closet_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_closet_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{bed4_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{bed4_comment_comment}</Text> 
        </View>
      </View>
    </View>




    {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! START OF FAMILY ROOM !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>FAMILY ROOM</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Light Fixtures:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_light_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_light_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Fireplace:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_fire_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_fire_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{family_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{family_comment_comment}</Text> 
        </View>
      </View>
    </View>
    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `page ${pageNumber} of ${totalPages}`
      )} fixed />
    </View>
    </Page>
    <Page  size="A4" style={styles.page}>
    <View style={styles.section}>
        <View style= {styles.image_div}>
        <Image style={styles.header_pic} src={Ardent_logo}></Image>
        <Image style={styles.header_pic} src={Ardent_address}></Image>
      </View>




    {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! START OF LAUNDRY ROOM !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>LAUNDRY ROOM</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Door:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_door_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_door_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Washer/Dryer:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_washer_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_washer_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Window:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{laundry_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{laundry_comment_comment}</Text> 
        </View>
      </View>
    </View>
    





    { /* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! START OF BASEMENT !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>BASEMENT</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Floors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_floor_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_floor_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Walls:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_wall_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_wall_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Ceiling:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_ceiling_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_ceiling_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Smoke/CO Detectors:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_smoke_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_smoke_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Windows/Screens:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_window_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_window_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Plumbing/Sump Pump:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_plumbing_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_plumbing_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Built-In Vacuum:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_vacuum_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_vacuum_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Hot Water Tank (type & age):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_hot_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_hot_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Oil/Gas/Electric Furnace (filters, last, service, date, etc.):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_oil_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_oil_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{basement_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{basement_comment_comment}</Text> 
        </View>
      </View>
    </View>





    {/* !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! START OF EXTERIOR !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!! */}
    <View style={styles.table}> 
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>EXTERIOR</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>CODE</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>COMMENTS</Text> 
        </View> 
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Lower Patio(s):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_patio_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_patio_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Upper Deck(s):</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_deck_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_deck_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Stairs:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_stairs_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_stairs_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Light Fixtures:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_light_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_light_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Roof:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_roof_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_roof_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Gutters & Downspouts:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_gutter_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_gutter_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Concrete Driveway/Walkways:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_driveway_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_driveway_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Siding:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_siding_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_siding_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Oil Tank/Heat Pump:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_oil_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_oil_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Garage/Carport:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_garage_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_garage_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Fencing:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_fencing_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_fencing_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Landscaping:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_landscaping_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_landscaping_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Shed:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_shed_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_shed_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Other:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_other_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_other_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>General Cleanliness:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_gc_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_gc_comment}</Text> 
        </View>
      </View>
      <View style={styles.tableRow}> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>Comments:</Text> 
        </View> 
        <View style={styles.tableCol}> 
          <Text style={styles.tableCell}>{exterior_comment_code}</Text> 
        </View> 
        <View style={styles.tableCol}>
          <Text style={styles.tableCell}>{exterior_comment_comment}</Text> 
        </View>
      </View>
    </View>
    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `page ${pageNumber} of ${totalPages}`
      )} fixed />
    </View>
    </Page>
    <Page>
      <View fixed>
      <View style= {styles.image_div}>
        <Image style={styles.header_pic} src={Ardent_logo}></Image>
        <Image style={styles.header_pic} src={Ardent_address}></Image>
      </View>


    <View>
      <Text  style={styles.sub_header}>Areas that may require the attention of the tenant(s):</Text>
      <Text>{"\n"}</Text>
      <Text style={styles.sub_text}>{tenantAttention}</Text>
      <Text>{"\n"}</Text>
      <Text>{"\n"}</Text>
    </View>

    <View>
      <Text  style={styles.sub_header}>Areas that may require the attention of the landlord:</Text>
      <Text>{"\n"}</Text>
      <Text style={styles.sub_text}>{landlordAttention}</Text>
      <Text>{"\n"}</Text>
      <Text>{"\n"}</Text>
    </View>


    <View>
      <Text style={styles.sub_header}>TENANT’S SIGNATURE:
       
        <Text>                                                Date: {currentDate}</Text>        
      </Text>
      <View style={styles.underlineTenat}></View>
      <View style={styles.underlineDate}></View>
      <Text>{"\n"}</Text>
      <Text>{"\n"}</Text>
    </View>

    <View>
      <Text style={styles.sub_header}>LANDLORD'S SIGNATURE:                                 
        <Text>                                                Date: {currentDate}</Text>     
      </Text>
      <View style={styles.underline}></View>
      <View style={styles.underlineDateLandlord}></View>
      <Text>{"\n"}</Text>
    </View>
    </View>
    <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
        `page ${pageNumber} of ${totalPages}`
      )} fixed />
    </Page>
  </Document>
  );
};


const RentalPdfPage = (props) => {
  

    const { landSignature, fileName, Address, tenantAttention, landlordAttention, tenantName, contact, currentDate, entrance_door_code, entrance_door_comment, entrance_floor_code, entrance_floor_comment, entrance_wall_code, entrance_wall_comment, entrance_ceiling_code, entrance_ceiling_comment, entrance_light_code, entrance_light_comment, entrance_smoke_code, entrance_smoke_comment, entrance_fire_code, entrance_fire_comment, entrance_closet_code, entrance_closet_comment, entrance_stairwell_code, entrance_stairwell_comment, entrance_gc_code, entrance_gc_comment, entrance_comment_code, entrance_comment_comment,  kitchen_appliances_code, kitchen_appliances_comment, kitchen_cabinetry_code , kitchen_cabinetry_comment , kitchen_plumbing_code , kitchen_plumbing_comment ,  kitchen_fan_code ,  kitchen_fan_comment , kitchen_window_code , kitchen_window_comment , kitchen_floor_code , kitchen_floor_comment , kitchen_ceiling_code ,  kitchen_ceiling_comment , kitchen_gc_code , kitchen_gc_comment , kitchen_comment_code , kitchen_comment_comment ,dining_floor_code , dining_floor_comment , dining_wall_code , dining_wall_comment , dining_ceiling_code , dining_ceiling_comment , dining_window_code , dining_window_comment , dining_gc_code , dining_gc_comment , dining_comment_code , dining_comment_comment ,living_floor_code , living_floor_comment , living_wall_code , living_wall_comment , living_ceiling_code , living_ceiling_comment , living_windows_code , living_windows_comment , living_fire_code , living_fire_comment , living_gc_code ,living_gc_comment , living_comment_code , living_comment_comment ,bath_m_door_code ,  bath_m_door_comment ,bath_m_floor_code ,bath_m_floor_comment , bath_m_cabinetry_code , bath_m_cabinetry_comment , bath_m_plumbing_code , bath_m_plumbing_comment , bath_m_bath_code , bath_m_bath_comment , bath_m_ceiling_code , bath_m_ceiling_comment , bath_m_light_code , bath_m_light_comment , bath_m_window_code , bath_m_window_comment , bath_m_gc_code , bath_m_gc_comment , bath_m_comment_code ,bath_m_comment_comment ,master_door_code , master_door_comment , master_floor_code , master_floor_comment , master_wall_code , master_wall_comment , master_ceiling_code , master_ceiling_comment , master_closet_code , master_closet_comment , master_window_code , master_window_comment , master_gc_code , master_gc_comment , master_comment_code ,master_comment_comment ,bath_e_door_code , bath_e_door_comment , bath_e_floor_code , bath_e_floor_comment , bath_e_walls_code, bath_e_walls_comment, bath_e_cabinetry_code , bath_e_cabinetry_comment , bath_e_plumbing_code , bath_e_plumbing_comment , bath_e_bath_code ,bath_e_bath_comment, bath_e_ceiling_code, bath_e_ceiling_comment ,bath_e_light_code , bath_e_light_comment, bath_e_window_code, bath_e_window_comment, bath_e_gc_code, bath_e_gc_comment, bath_e_comment_code,bath_e_comment_comment, bed2_door_code, bed2_door_comment, bed2_floor_code ,bed2_floor_comment, bed2_wall_code, bed2_wall_comment, bed2_ceiling_code, bed2_ceiling_comment , bed2_closet_code , bed2_closet_comment, bed2_window_code , bed2_window_comment , bed2_gc_code , bed2_gc_comment ,bed2_comment_code,bed2_comment_comment,bed3_door_code, bed3_door_comment, bed3_floor_code, bed3_floor_comment, bed3_wall_code , bed3_wall_comment , bed3_ceiling_code ,bed3_ceiling_comment , bed3_closet_code , bed3_closet_comment, bed3_window_code, bed3_window_comment ,  bed3_gc_code ,  bed3_gc_comment , bed3_comment_code ,bed3_comment_comment ,bed4_door_code, bed4_door_comment, bed4_floor_code, bed4_floor_comment, bed4_wall_code, bed4_wall_comment, bed4_ceiling_code, bed4_ceiling_comment, bed4_closet_code,  bed4_closet_comment, bed4_window_code, bed4_window_comment, bed4_gc_code, bed4_gc_comment, bed4_comment_code,bed4_comment_comment,family_floor_code, family_floor_comment, family_wall_code, family_wall_comment, family_ceiling_code, family_ceiling_comment, family_light_code, family_light_comment, family_window_code, family_window_comment,family_fire_code, family_fire_comment,  family_gc_code, family_gc_comment, family_comment_code,family_comment_comment, laundry_door_code, laundry_door_comment, laundry_floor_code, laundry_floor_comment, laundry_wall_code, laundry_wall_comment,laundry_ceiling_code, laundry_ceiling_comment, laundry_washer_code, laundry_washer_comment, laundry_window_code, laundry_window_comment, laundry_gc_code, laundry_gc_comment, laundry_comment_code,laundry_comment_comment,basement_floor_code, basement_floor_comment, basement_wall_code, basement_wall_comment, basement_ceiling_code, basement_ceiling_comment, basement_smoke_code, basement_smoke_comment, basement_window_code, basement_window_comment, basement_plumbing_code, basement_plumbing_comment, basement_vacuum_code, basement_vacuum_comment, basement_hot_code, basement_hot_comment, basement_oil_code, basement_oil_comment, basement_gc_code, basement_gc_comment, basement_comment_code, basement_comment_comment, exterior_patio_code, exterior_patio_comment, exterior_deck_code, exterior_deck_comment, exterior_stairs_code, exterior_stairs_comment, exterior_light_code, exterior_light_comment, exterior_roof_code, exterior_roof_comment, exterior_gutter_code, exterior_gutter_comment, exterior_driveway_code, exterior_driveway_comment, exterior_siding_code, exterior_siding_comment, exterior_oil_code, exterior_oil_comment, exterior_garage_code, exterior_garage_comment, exterior_fencing_code, exterior_fencing_comment, exterior_landscaping_code, exterior_landscaping_comment, exterior_shed_code, exterior_shed_comment, exterior_other_code, exterior_other_comment, exterior_gc_code, exterior_gc_comment, exterior_comment_code, exterior_comment_comment } =
    (props.location && props.location.state) || {};

    console.log({fileName})
    

return (
    <div>
      
        
        <PDFViewer className='pdf-viewer'>
            <MyDocument landSignature={landSignature} fileName={fileName} Address={Address} tenantAttention={tenantAttention} landlordAttention={landlordAttention} tenantName={tenantName} contact={contact} currentDate={currentDate} entrance_door_code = {entrance_door_code} entrance_door_comment = {entrance_door_comment} entrance_floor_code = {entrance_floor_code} entrance_floor_comment = {entrance_floor_comment} entrance_wall_code = {entrance_wall_code} entrance_wall_comment = {entrance_wall_comment} entrance_ceiling_code = {entrance_ceiling_code} entrance_ceiling_comment = {entrance_ceiling_comment} entrance_light_code = {entrance_light_code} entrance_light_comment = {entrance_light_comment} entrance_smoke_code = {entrance_smoke_code} entrance_smoke_comment = {entrance_smoke_comment} entrance_fire_code = {entrance_fire_code} entrance_fire_comment = {entrance_fire_comment} entrance_closet_code = {entrance_closet_code} entrance_closet_comment = {entrance_closet_comment} entrance_stairwell_code = { entrance_stairwell_code} entrance_stairwell_comment = { entrance_stairwell_comment} entrance_gc_code = {entrance_gc_code} entrance_gc_comment = {entrance_gc_comment} entrance_comment_code = {entrance_comment_code} entrance_comment_comment={entrance_comment_comment}  kitchen_appliances_code={kitchen_appliances_code}  kitchen_appliances_comment={kitchen_appliances_comment}  kitchen_cabinetry_code={kitchen_cabinetry_code} kitchen_cabinetry_comment={kitchen_cabinetry_comment} kitchen_plumbing_code={kitchen_plumbing_code} kitchen_plumbing_comment={kitchen_plumbing_comment}  kitchen_fan_code={kitchen_fan_code} kitchen_fan_comment={kitchen_fan_comment}   kitchen_window_code={kitchen_window_code} kitchen_window_comment={kitchen_window_comment} kitchen_floor_code={kitchen_floor_code} kitchen_floor_comment={kitchen_floor_comment} kitchen_ceiling_code={kitchen_ceiling_code} kitchen_ceiling_comment={kitchen_ceiling_comment} kitchen_gc_code={kitchen_gc_code} kitchen_gc_comment={kitchen_gc_comment} kitchen_comment_code={kitchen_comment_code} kitchen_comment_comment={kitchen_comment_comment}  dining_floor_code={dining_floor_code} dining_floor_comment={dining_floor_comment} dining_wall_code={dining_wall_code} dining_wall_comment={dining_wall_comment} dining_ceiling_code={dining_ceiling_code}  dining_ceiling_comment={dining_ceiling_comment}   dining_window_code={dining_window_code}   dining_window_comment={dining_window_comment}   dining_gc_code={dining_gc_code}   dining_gc_comment={dining_gc_comment}   dining_comment_code={dining_comment_code}   dining_comment_comment={dining_comment_comment}  living_floor_code={living_floor_code}   living_floor_comment={living_floor_comment}   living_wall_code={living_wall_code}   living_wall_comment={living_wall_comment}   living_ceiling_code={living_ceiling_code}   living_ceiling_comment={living_ceiling_comment}   living_windows_code={living_windows_code}   living_windows_comment={living_windows_comment}   living_fire_code={living_fire_code}   living_fire_comment={living_fire_comment}   living_gc_code={living_gc_code}  living_gc_comment={living_gc_comment}   living_comment_code={living_comment_code}   living_comment_comment={living_comment_comment}  bath_m_door_code={bath_m_door_code}    bath_m_door_comment={bath_m_door_comment}  bath_m_floor_code={bath_m_floor_code}  bath_m_floor_comment={bath_m_floor_comment}   bath_m_cabinetry_code={bath_m_cabinetry_code}   bath_m_cabinetry_comment={bath_m_cabinetry_comment}   bath_m_plumbing_code={bath_m_plumbing_code}   bath_m_plumbing_comment={bath_m_plumbing_comment}   bath_m_bath_code={bath_m_bath_code}   bath_m_bath_comment={bath_m_bath_comment}   bath_m_ceiling_code={bath_m_ceiling_code}   bath_m_ceiling_comment={bath_m_ceiling_comment}   bath_m_light_code={bath_m_light_code}   bath_m_light_comment={bath_m_light_comment}   bath_m_window_code={bath_m_window_code}   bath_m_window_comment={bath_m_window_comment}   bath_m_gc_code={bath_m_gc_code}   bath_m_gc_comment={bath_m_gc_comment}   bath_m_comment_code={bath_m_comment_code}  bath_m_comment_comment={bath_m_comment_comment}  master_door_code={master_door_code}   master_door_comment={master_door_comment}   master_floor_code={master_floor_code}   master_floor_comment={master_floor_comment}   master_wall_code={master_wall_code}   master_wall_comment={master_wall_comment}   master_ceiling_code={master_ceiling_code}   master_ceiling_comment={master_ceiling_comment}   master_closet_code={master_closet_code}   master_closet_comment={master_closet_comment}   master_window_code={master_window_code}   master_window_comment={master_window_comment}   master_gc_code={master_gc_code}   master_gc_comment={master_gc_comment}   master_comment_code={master_comment_code}  master_comment_comment={master_comment_comment}  bath_e_door_code={bath_e_door_code}   bath_e_door_comment={bath_e_door_comment}   bath_e_floor_code={bath_e_floor_code}   bath_e_floor_comment={bath_e_floor_comment} bath_e_walls_code={bath_e_walls_code} bath_e_walls_comment={bath_e_walls_comment}   bath_e_cabinetry_code={bath_e_cabinetry_code}   bath_e_cabinetry_comment={bath_e_cabinetry_comment}   bath_e_plumbing_code={bath_e_plumbing_code}   bath_e_plumbing_comment={bath_e_plumbing_comment}   bath_e_bath_code={bath_e_bath_code}  bath_e_bath_comment={bath_e_bath_comment}  bath_e_ceiling_code={bath_e_ceiling_code}  bath_e_ceiling_comment={bath_e_ceiling_comment}  bath_e_light_code={bath_e_light_code}   bath_e_light_comment={bath_e_light_comment}  bath_e_window_code={bath_e_window_code}  bath_e_window_comment={bath_e_window_comment}  bath_e_gc_code={bath_e_gc_code}  bath_e_gc_comment={bath_e_gc_comment}  bath_e_comment_code={bath_e_comment_code} bath_e_comment_comment={bath_e_comment_comment}  bed2_door_code={bed2_door_code}  bed2_door_comment={bed2_door_comment}  bed2_floor_code={bed2_floor_code}  bed2_floor_comment={bed2_floor_comment}  bed2_wall_code={bed2_wall_code}  bed2_wall_comment={bed2_wall_comment}  bed2_ceiling_code={bed2_ceiling_code}  bed2_ceiling_comment={bed2_ceiling_comment}   bed2_closet_code={bed2_closet_code}   bed2_closet_comment={bed2_closet_comment}  bed2_window_code={bed2_window_code} bed2_window_comment={bed2_window_comment} bed2_gc_code={bed2_gc_code} bed2_gc_comment={bed2_gc_comment}  bed2_comment_code={bed2_comment_code} bed2_comment_comment={bed2_comment_comment} bed3_door_code={bed3_door_code}  bed3_door_comment={bed3_door_comment}  bed3_floor_code={bed3_floor_code}  bed3_floor_comment={bed3_floor_comment}  bed3_wall_code={bed3_wall_code}   bed3_wall_comment={bed3_wall_comment}   bed3_ceiling_code={bed3_ceiling_code}  bed3_ceiling_comment={bed3_ceiling_comment}   bed3_closet_code={bed3_closet_code} bed3_closet_comment={bed3_closet_comment}  bed3_window_code={bed3_window_code}  bed3_window_comment={bed3_window_comment}    bed3_gc_code={bed3_gc_code}    bed3_gc_comment={bed3_gc_comment}   bed3_comment_code={bed3_comment_code}  bed3_comment_comment={bed3_comment_comment}  bed4_door_code={bed4_door_code}  bed4_door_comment={bed4_door_comment}  bed4_floor_code={bed4_floor_code}  bed4_floor_comment={bed4_floor_comment}  bed4_wall_code={bed4_wall_code}  bed4_wall_comment={bed4_wall_comment}  bed4_ceiling_code={bed4_ceiling_code}  bed4_ceiling_comment={bed4_ceiling_comment}  bed4_closet_code={bed4_closet_code}   bed4_closet_comment={bed4_closet_comment}  bed4_window_code={bed4_window_code}  bed4_window_comment={bed4_window_comment}  bed4_gc_code={bed4_gc_code}  bed4_gc_comment={bed4_gc_comment}  bed4_comment_code={bed4_comment_code} bed4_comment_comment={bed4_comment_comment} family_floor_code={family_floor_code}  family_floor_comment={family_floor_comment} family_wall_code={family_wall_code}  family_wall_comment={family_wall_comment}  family_ceiling_code={family_ceiling_code}  family_ceiling_comment={family_ceiling_comment}  family_light_code={family_light_code}  family_light_comment={family_light_comment}  family_window_code={family_window_code}  family_window_comment={family_window_comment}  family_fire_code={family_fire_code}  family_fire_comment={family_fire_comment}   family_gc_code={family_gc_code}  family_gc_comment={family_gc_comment}  family_comment_code={family_comment_code} family_comment_comment={family_comment_comment}  laundry_door_code={laundry_door_code}  laundry_door_comment={laundry_door_comment}  laundry_floor_code={laundry_floor_code}  laundry_floor_comment={laundry_floor_comment}  laundry_wall_code={laundry_wall_code}  laundry_wall_comment={laundry_wall_comment} laundry_ceiling_code={laundry_ceiling_code}  laundry_ceiling_comment={laundry_ceiling_comment}  laundry_washer_code={laundry_washer_code}  laundry_washer_comment={laundry_washer_comment} laundry_window_code={laundry_window_code}  laundry_window_comment={laundry_window_comment}  laundry_gc_code={laundry_gc_code}  laundry_gc_comment={laundry_gc_comment}  laundry_comment_code={laundry_comment_code} laundry_comment_comment={laundry_comment_comment} basement_floor_code={basement_floor_code}  basement_floor_comment={basement_floor_comment}  basement_wall_code={basement_wall_code}  basement_wall_comment={basement_wall_comment}  basement_ceiling_code={basement_ceiling_code}  basement_ceiling_comment={basement_ceiling_comment}  basement_smoke_code={basement_smoke_code}  basement_smoke_comment={basement_smoke_comment}  basement_window_code={basement_window_code}  basement_window_comment={basement_window_comment}  basement_plumbing_code={basement_plumbing_code}  basement_plumbing_comment={basement_plumbing_comment}  basement_vacuum_code={basement_vacuum_code}  basement_vacuum_comment={basement_vacuum_comment}  basement_hot_code={basement_hot_code}  basement_hot_comment={basement_hot_comment}  basement_oil_code={basement_oil_code}  basement_oil_comment={basement_oil_comment}  basement_gc_code={basement_gc_code}  basement_gc_comment={basement_gc_comment}  basement_comment_code={basement_comment_code} basement_comment_comment={basement_comment_comment}  exterior_patio_code={exterior_patio_code}  exterior_patio_comment={exterior_patio_comment}  exterior_deck_code={exterior_deck_code}  exterior_deck_comment={exterior_deck_comment}  exterior_stairs_code={exterior_stairs_code}  exterior_stairs_comment={exterior_stairs_comment}  exterior_light_code={exterior_light_code}  exterior_light_comment={exterior_light_comment}  exterior_roof_code={exterior_roof_code}  exterior_roof_comment={exterior_roof_comment}  exterior_gutter_code={exterior_gutter_code}  exterior_gutter_comment={exterior_gutter_comment}  exterior_driveway_code={exterior_driveway_code}  exterior_driveway_comment={exterior_driveway_comment}  exterior_siding_code={exterior_siding_code}  exterior_siding_comment={exterior_siding_comment}  exterior_oil_code={exterior_oil_code}  exterior_oil_comment={exterior_oil_comment}  exterior_garage_code={exterior_garage_code}  exterior_garage_comment={exterior_garage_comment}  exterior_fencing_code={exterior_fencing_code}  exterior_fencing_comment={exterior_fencing_comment}  exterior_landscaping_code={exterior_landscaping_code}  exterior_landscaping_comment={exterior_landscaping_comment}  exterior_shed_code={exterior_shed_code}  exterior_shed_comment={exterior_shed_comment}  exterior_other_code={exterior_other_code}  exterior_other_comment={exterior_other_comment}  exterior_gc_code={exterior_gc_code}  exterior_gc_comment={exterior_gc_comment}  exterior_comment_code={exterior_comment_code}  exterior_comment_comment={exterior_comment_comment}/>
        </PDFViewer> 
      <div className='rental-div'>
      <PDFDownloadLink document={<MyDocument landSignature={landSignature} fileName={fileName} Address={Address} tenantAttention={tenantAttention} landlordAttention={landlordAttention} tenantName={tenantName} contact={contact} currentDate={currentDate} entrance_door_code = {entrance_door_code} entrance_door_comment = {entrance_door_comment} entrance_floor_code = {entrance_floor_code} entrance_floor_comment = {entrance_floor_comment} entrance_wall_code = {entrance_wall_code} entrance_wall_comment = {entrance_wall_comment} entrance_ceiling_code = {entrance_ceiling_code} entrance_ceiling_comment = {entrance_ceiling_comment} entrance_light_code = {entrance_light_code} entrance_light_comment = {entrance_light_comment} entrance_smoke_code = {entrance_smoke_code} entrance_smoke_comment = {entrance_smoke_comment} entrance_fire_code = {entrance_fire_code} entrance_fire_comment = {entrance_fire_comment} entrance_closet_code = {entrance_closet_code} entrance_closet_comment = {entrance_closet_comment} entrance_stairwell_code = { entrance_stairwell_code} entrance_stairwell_comment = { entrance_stairwell_comment} entrance_gc_code = {entrance_gc_code} entrance_gc_comment = {entrance_gc_comment} entrance_comment_code = {entrance_comment_code} entrance_comment_comment={entrance_comment_comment}  kitchen_appliances_code={kitchen_appliances_code}  kitchen_appliances_comment={kitchen_appliances_comment}  kitchen_cabinetry_code={kitchen_cabinetry_code} kitchen_cabinetry_comment={kitchen_cabinetry_comment} kitchen_plumbing_code={kitchen_plumbing_code} kitchen_plumbing_comment={kitchen_plumbing_comment}  kitchen_fan_code={kitchen_fan_code} kitchen_fan_comment={kitchen_fan_comment}   kitchen_window_code={kitchen_window_code} kitchen_window_comment={kitchen_window_comment} kitchen_floor_code={kitchen_floor_code} kitchen_floor_comment={kitchen_floor_comment} kitchen_ceiling_code={kitchen_ceiling_code} kitchen_ceiling_comment={kitchen_ceiling_comment} kitchen_gc_code={kitchen_gc_code} kitchen_gc_comment={kitchen_gc_comment} kitchen_comment_code={kitchen_comment_code} kitchen_comment_comment={kitchen_comment_comment}  dining_floor_code={dining_floor_code} dining_floor_comment={dining_floor_comment} dining_wall_code={dining_wall_code} dining_wall_comment={dining_wall_comment} dining_ceiling_code={dining_ceiling_code}  dining_ceiling_comment={dining_ceiling_comment}   dining_window_code={dining_window_code}   dining_window_comment={dining_window_comment}   dining_gc_code={dining_gc_code}   dining_gc_comment={dining_gc_comment}   dining_comment_code={dining_comment_code}   dining_comment_comment={dining_comment_comment}  living_floor_code={living_floor_code}   living_floor_comment={living_floor_comment}   living_wall_code={living_wall_code}   living_wall_comment={living_wall_comment}   living_ceiling_code={living_ceiling_code}   living_ceiling_comment={living_ceiling_comment}   living_windows_code={living_windows_code}   living_windows_comment={living_windows_comment}   living_fire_code={living_fire_code}   living_fire_comment={living_fire_comment}   living_gc_code={living_gc_code}  living_gc_comment={living_gc_comment}   living_comment_code={living_comment_code}   living_comment_comment={living_comment_comment}  bath_m_door_code={bath_m_door_code}    bath_m_door_comment={bath_m_door_comment}  bath_m_floor_code={bath_m_floor_code}  bath_m_floor_comment={bath_m_floor_comment}   bath_m_cabinetry_code={bath_m_cabinetry_code}   bath_m_cabinetry_comment={bath_m_cabinetry_comment}   bath_m_plumbing_code={bath_m_plumbing_code}   bath_m_plumbing_comment={bath_m_plumbing_comment}   bath_m_bath_code={bath_m_bath_code}   bath_m_bath_comment={bath_m_bath_comment}   bath_m_ceiling_code={bath_m_ceiling_code}   bath_m_ceiling_comment={bath_m_ceiling_comment}   bath_m_light_code={bath_m_light_code}   bath_m_light_comment={bath_m_light_comment}   bath_m_window_code={bath_m_window_code}   bath_m_window_comment={bath_m_window_comment}   bath_m_gc_code={bath_m_gc_code}   bath_m_gc_comment={bath_m_gc_comment}   bath_m_comment_code={bath_m_comment_code}  bath_m_comment_comment={bath_m_comment_comment}  master_door_code={master_door_code}   master_door_comment={master_door_comment}   master_floor_code={master_floor_code}   master_floor_comment={master_floor_comment}   master_wall_code={master_wall_code}   master_wall_comment={master_wall_comment}   master_ceiling_code={master_ceiling_code}   master_ceiling_comment={master_ceiling_comment}   master_closet_code={master_closet_code}   master_closet_comment={master_closet_comment}   master_window_code={master_window_code}   master_window_comment={master_window_comment}   master_gc_code={master_gc_code}   master_gc_comment={master_gc_comment}   master_comment_code={master_comment_code}  master_comment_comment={master_comment_comment}  bath_e_door_code={bath_e_door_code}   bath_e_door_comment={bath_e_door_comment}   bath_e_floor_code={bath_e_floor_code}   bath_e_floor_comment={bath_e_floor_comment} bath_e_walls_code={bath_e_walls_code} bath_e_walls_comment={bath_e_walls_comment}   bath_e_cabinetry_code={bath_e_cabinetry_code}   bath_e_cabinetry_comment={bath_e_cabinetry_comment}   bath_e_plumbing_code={bath_e_plumbing_code}   bath_e_plumbing_comment={bath_e_plumbing_comment}   bath_e_bath_code={bath_e_bath_code}  bath_e_bath_comment={bath_e_bath_comment}  bath_e_ceiling_code={bath_e_ceiling_code}  bath_e_ceiling_comment={bath_e_ceiling_comment}  bath_e_light_code={bath_e_light_code}   bath_e_light_comment={bath_e_light_comment}  bath_e_window_code={bath_e_window_code}  bath_e_window_comment={bath_e_window_comment}  bath_e_gc_code={bath_e_gc_code}  bath_e_gc_comment={bath_e_gc_comment}  bath_e_comment_code={bath_e_comment_code} bath_e_comment_comment={bath_e_comment_comment}  bed2_door_code={bed2_door_code}  bed2_door_comment={bed2_door_comment}  bed2_floor_code={bed2_floor_code}  bed2_floor_comment={bed2_floor_comment}  bed2_wall_code={bed2_wall_code}  bed2_wall_comment={bed2_wall_comment}  bed2_ceiling_code={bed2_ceiling_code}  bed2_ceiling_comment={bed2_ceiling_comment}   bed2_closet_code={bed2_closet_code}   bed2_closet_comment={bed2_closet_comment}  bed2_window_code={bed2_window_code} bed2_window_comment={bed2_window_comment} bed2_gc_code={bed2_gc_code} bed2_gc_comment={bed2_gc_comment}  bed2_comment_code={bed2_comment_code} bed2_comment_comment={bed2_comment_comment} bed3_door_code={bed3_door_code}  bed3_door_comment={bed3_door_comment}  bed3_floor_code={bed3_floor_code}  bed3_floor_comment={bed3_floor_comment}  bed3_wall_code={bed3_wall_code}   bed3_wall_comment={bed3_wall_comment}   bed3_ceiling_code={bed3_ceiling_code}  bed3_ceiling_comment={bed3_ceiling_comment}   bed3_closet_code={bed3_closet_code} bed3_closet_comment={bed3_closet_comment}  bed3_window_code={bed3_window_code}  bed3_window_comment={bed3_window_comment}    bed3_gc_code={bed3_gc_code}    bed3_gc_comment={bed3_gc_comment}   bed3_comment_code={bed3_comment_code}  bed3_comment_comment={bed3_comment_comment}  bed4_door_code={bed4_door_code}  bed4_door_comment={bed4_door_comment}  bed4_floor_code={bed4_floor_code}  bed4_floor_comment={bed4_floor_comment}  bed4_wall_code={bed4_wall_code}  bed4_wall_comment={bed4_wall_comment}  bed4_ceiling_code={bed4_ceiling_code}  bed4_ceiling_comment={bed4_ceiling_comment}  bed4_closet_code={bed4_closet_code}   bed4_closet_comment={bed4_closet_comment}  bed4_window_code={bed4_window_code}  bed4_window_comment={bed4_window_comment}  bed4_gc_code={bed4_gc_code}  bed4_gc_comment={bed4_gc_comment}  bed4_comment_code={bed4_comment_code} bed4_comment_comment={bed4_comment_comment} family_floor_code={family_floor_code}  family_floor_comment={family_floor_comment} family_wall_code={family_wall_code}  family_wall_comment={family_wall_comment}  family_ceiling_code={family_ceiling_code}  family_ceiling_comment={family_ceiling_comment}  family_light_code={family_light_code}  family_light_comment={family_light_comment}  family_window_code={family_window_code}  family_window_comment={family_window_comment}  family_fire_code={family_fire_code}  family_fire_comment={family_fire_comment}   family_gc_code={family_gc_code}  family_gc_comment={family_gc_comment}  family_comment_code={family_comment_code} family_comment_comment={family_comment_comment}  laundry_door_code={laundry_door_code}  laundry_door_comment={laundry_door_comment}  laundry_floor_code={laundry_floor_code}  laundry_floor_comment={laundry_floor_comment}  laundry_wall_code={laundry_wall_code}  laundry_wall_comment={laundry_wall_comment} laundry_ceiling_code={laundry_ceiling_code}  laundry_ceiling_comment={laundry_ceiling_comment}  laundry_washer_code={laundry_washer_code}  laundry_washer_comment={laundry_washer_comment} laundry_window_code={laundry_window_code}  laundry_window_comment={laundry_window_comment}  laundry_gc_code={laundry_gc_code}  laundry_gc_comment={laundry_gc_comment}  laundry_comment_code={laundry_comment_code} laundry_comment_comment={laundry_comment_comment} basement_floor_code={basement_floor_code}  basement_floor_comment={basement_floor_comment}  basement_wall_code={basement_wall_code}  basement_wall_comment={basement_wall_comment}  basement_ceiling_code={basement_ceiling_code}  basement_ceiling_comment={basement_ceiling_comment}  basement_smoke_code={basement_smoke_code}  basement_smoke_comment={basement_smoke_comment}  basement_window_code={basement_window_code}  basement_window_comment={basement_window_comment}  basement_plumbing_code={basement_plumbing_code}  basement_plumbing_comment={basement_plumbing_comment}  basement_vacuum_code={basement_vacuum_code}  basement_vacuum_comment={basement_vacuum_comment}  basement_hot_code={basement_hot_code}  basement_hot_comment={basement_hot_comment}  basement_oil_code={basement_oil_code}  basement_oil_comment={basement_oil_comment}  basement_gc_code={basement_gc_code}  basement_gc_comment={basement_gc_comment}  basement_comment_code={basement_comment_code} basement_comment_comment={basement_comment_comment}  exterior_patio_code={exterior_patio_code}  exterior_patio_comment={exterior_patio_comment}  exterior_deck_code={exterior_deck_code}  exterior_deck_comment={exterior_deck_comment}  exterior_stairs_code={exterior_stairs_code}  exterior_stairs_comment={exterior_stairs_comment}  exterior_light_code={exterior_light_code}  exterior_light_comment={exterior_light_comment}  exterior_roof_code={exterior_roof_code}  exterior_roof_comment={exterior_roof_comment}  exterior_gutter_code={exterior_gutter_code}  exterior_gutter_comment={exterior_gutter_comment}  exterior_driveway_code={exterior_driveway_code}  exterior_driveway_comment={exterior_driveway_comment}  exterior_siding_code={exterior_siding_code}  exterior_siding_comment={exterior_siding_comment}  exterior_oil_code={exterior_oil_code}  exterior_oil_comment={exterior_oil_comment}  exterior_garage_code={exterior_garage_code}  exterior_garage_comment={exterior_garage_comment}  exterior_fencing_code={exterior_fencing_code}  exterior_fencing_comment={exterior_fencing_comment}  exterior_landscaping_code={exterior_landscaping_code}  exterior_landscaping_comment={exterior_landscaping_comment}  exterior_shed_code={exterior_shed_code}  exterior_shed_comment={exterior_shed_comment}  exterior_other_code={exterior_other_code}  exterior_other_comment={exterior_other_comment}  exterior_gc_code={exterior_gc_code}  exterior_gc_comment={exterior_gc_comment}  exterior_comment_code={exterior_comment_code}  exterior_comment_comment={exterior_comment_comment} />} fileName={fileName}>
        {({ blob, url, loading, error }) =>
          loading ? (
            "Loading document..."
          ) : (
            <div className="d-flex justify-content-center download-button">
              <button className='rental-page-link'>Download</button>
            </div>
          )
        }
      </PDFDownloadLink>

      <Link className='rental-page-link' to='/introSection'> BACK</Link>
      </div>
    </div>
  );
};

export const SaveBtn = () => {
  return <div></div>;
};


//for testing only
const Details = props => {
    const { username, email, city, phone } =
      (props.location && props.location.state) || {};
    return (
      <div>

        <div className="form-details">
          <div>
            <strong>Username:</strong> {username}
          </div>
          <div>
            <strong>Email:</strong> {email}
          </div>
          <div>
            <strong>City:</strong> {city}
          </div>
          <div>
            <strong>Phone:</strong> {phone}
          </div>
        </div>
      </div>
    );
  };
  
  export default RentalPdfPage;
